// extracted by mini-css-extract-plugin
export var divider = "_lw-0";
export var systemMessage = "_lw-1";
export var systemMessageWrapper = "_lw-2";